/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */

import React from 'react';

import _ from 'lodash';
import {connect} from 'react-redux';

import * as modalActions from '@/actions/modalActions';
import * as setupActions from '@/actions/setupActions';
// import {Post} from '@/api/request';
import RenameIcon from '@/assets/icons/Edit.svg';
import HelpIcon from '@/assets/icons/Question.svg';
import ResetDefaultIconDisable from '@/assets/icons/Reset-To-Default-Disable.svg';
import ResetDefaultIcon from '@/assets/icons/Reset-To-Default.svg';
import {validateNameAdvSetup} from '@/businesses/advSetupBusiness';
import PopUpWizard from '@/components/popup/PopUpWizard';
// import {CREATE} from '@/constants/apis';
import * as APPDATA from '@/constants/pcConstAppData';
import * as PC_COMMON_FUNCTION from '@/libs/appHelper';
import {consoleLog} from '@/libs/consoleHelper';

import {
  DataHelpHome,
  DataHelpConcentrate,
  DataHelpConcentrateMoreThan50,
  DataHelpBufferDiscrete,
  DataHelpBufferContinuous,
  DataHelpAdvancedSetup,
  DataHelpManualControl,
  DataHelpStatusAndGraph,
  DataHelpRecovery,
  // nextPage,
} from '../../autoProfile/help/AutoProfileHelp';

@connect((store) => ({
  advSetupList: store.setupStore.advSetupList,
  skipPriming: store.setupStore.advSetupSelected
    ? store.setupStore.advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.GeneralAdvSetup][
        APPDATA.KEY.SkipPriming
      ]
    : undefined,
  membraneFillingCycle: store.setupStore.advSetupSelected
    ? store.setupStore.advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.GeneralAdvSetup][
        APPDATA.KEY.MembraneFillingCycle
      ]
    : undefined,
  manualControlThreshold: store.setupStore.advSetupSelected
    ? store.setupStore.advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.GeneralAdvSetup][
        APPDATA.KEY.ManualControlThreshold
      ]
    : undefined,

  pressureAdvSetup: store.setupStore.advSetupSelected
    ? store.setupStore.advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.MainAdvSetup][
        APPDATA.KEY.PressureAdvSetup
      ]
    : undefined,
  diaphragmTiming: store.setupStore.advSetupSelected
    ? store.setupStore.advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.MainAdvSetup][
        APPDATA.KEY.DiaphragmTiming
      ]
    : undefined,
  valveTiming: store.setupStore.advSetupSelected
    ? store.setupStore.advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.MainAdvSetup][APPDATA.KEY.ValveTiming]
    : undefined,

  pressureAdvSetup1: store.setupStore.advSetupSelected
    ? store.setupStore.advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.PrimeAdvSetup][
        APPDATA.KEY.PressureAdvSetup
      ]
    : undefined,
  diaphragmTiming1: store.setupStore.advSetupSelected
    ? store.setupStore.advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.PrimeAdvSetup][
        APPDATA.KEY.DiaphragmTiming
      ]
    : undefined,
  valveTiming1: store.setupStore.advSetupSelected
    ? store.setupStore.advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.PrimeAdvSetup][APPDATA.KEY.ValveTiming]
    : undefined,
  durationOfPrime1: store.setupStore.advSetupSelected
    ? store.setupStore.advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.PrimeAdvSetup][APPDATA.KEY.Duration]
    : undefined,

  pressureAdvSetup2: store.setupStore.advSetupSelected
    ? store.setupStore.advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.RecoveryAdvSetup][
        APPDATA.KEY.PressureAdvSetup
      ]
    : undefined,
  diaphragmTiming2: store.setupStore.advSetupSelected
    ? store.setupStore.advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.RecoveryAdvSetup][
        APPDATA.KEY.DiaphragmTiming
      ]
    : undefined,
  valveTiming2: store.setupStore.advSetupSelected
    ? store.setupStore.advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.RecoveryAdvSetup][
        APPDATA.KEY.ValveTiming
      ]
    : undefined,
  durationOfRecovery2: store.setupStore.advSetupSelected
    ? store.setupStore.advSetupSelected[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.RecoveryAdvSetup][APPDATA.KEY.Duration]
    : undefined,
  currentAdvSetupParams: store.setupStore.currentAdvSetupParams,
  defaultConfigAdvSetupParams: store.setupStore.defaultConfigAdvSetupParams,
  fontSize: store.setupStore.fontSize,
  lockAccess: store.setupStore.lockAccess,
  isPCRunning: store.setupStore.isPCRunning,
  editAdvSetup: store.setupStore.editAdvSetup,
  disableSaveSetupButton: store.setupStore.disableSaveSetupButton,
  advSetupSelected: store.setupStore.advSetupSelected,
  lastAdvSetupIdCreated: store.setupStore.lastAdvSetupIdCreated,
  modeHelp: store.setupStore.modeHelp,
}))
export default class AdvSetupTopMenu extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      activeMenu: undefined,
      // nameAdvSetup: undefined,
      isResetDefaultActive: false,
      isDefaultConfig: false,
      totalAdvSetup: undefined,
      beforeName: undefined,
      beforeConfig: undefined,
      isHelpModeEnable: false,
      contentHelp: DataHelpHome,
      triggerSave: false,
      // isKeyboardError: false,
    };
    // this.isButtonResetHidden = false;
    // this._bus = EventBusObject();
    // this.successSaveAdvSetup = this.successSaveAdvSetup.bind(this);
  }

  componentDidMount() {
    this.checkValidAdvSetup();
    this.props.dispatch(setupActions.updateActiveMenu(this.props.activeTopMenu));
    // this.setupTopMenuProperties(this.state.isResetDefaultActive)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    consoleLog('componentWillReceiveProps', nextProps, this.props, this.state.triggerSave);
    this.updateSaveButton(nextProps);
    this.updateCurrentAdv(nextProps);
  }

  checkValidAdvSetup = () => {
    const {editAdvSetup, advSetupSelected, isRemoteView} = this.props;
    consoleLog('checkValidAdvSetup', this.props);
    if (this.props.defaultConfigAdvSetupParams[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.GeneralAdvSetup] === undefined) {
      window.location.href = APPDATA.AUTO_PROFILE_SETUP;
    } else {
      if (advSetupSelected !== undefined) this.compareCurrentParamWithDefaultValue(advSetupSelected);
      if (editAdvSetup || isRemoteView) {
        const currentAdvSetup = PC_COMMON_FUNCTION.createNewJsonObject(advSetupSelected);
        this.setState({
          beforeConfig: currentAdvSetup,
        });
      }
    }
  };

  setupTopMenuProperties = (isResetDefaultActive) => {
    const {editAdvSetup, advSetupSelected, isRemoteView} = this.props;
    const {isDefaultConfig} = this.state;
    const button1Properties = {
      id: APPDATA.FIND_SETUP,
      label: APPDATA.FIND_SETUP,
      onClick: this.handleTopMenuClick,
      disabled: false,
    };
    const button2Properties = {
      id: APPDATA.SAVE,
      label: APPDATA.SAVE_SETUP,
      onClick: this.handleTopMenuClick,
      disabled: !this.props.disableSaveSetupButton,
    };
    const buttonSaveProperties = {
      id: APPDATA.SAVE,
      label: APPDATA.SAVE,
      onClick: this.handleTopMenuClick,
      disabled: !this.props.disableSaveSetupButton,
    };
    const buttonSaveASProperties = {
      id: APPDATA.SAVE_AS,
      label: APPDATA.SAVE_AS,
      onClick: this.handleTopMenuClick,
      disabled: !this.props.disableSaveSetupButton,
    };
    const buttonSaveSetupASProperties = {
      id: APPDATA.SAVE_AS,
      label: APPDATA.SAVE_SETUP_AS,
      onClick: this.handleTopMenuClick,
      disabled: !this.props.disableSaveSetupButton,
    };
    const backButtonProperties = {
      id: APPDATA.BACK,
      label: '',
      disabled: false,
      onClick: this.backAction,
    };
    // const backEditButtonProperties = {
    //   id: APPDATA.BACK,
    //   label: '',
    //   disabled: false,
    //   onClick: this.backAction,
    // };
    let titleMenuProperties = APPDATA.ADVANCED_SETUP_NEW;
    const resetDefaultProperties = {
      id: APPDATA.RESET_DEFAULT,
      label: '',
      disabled: !isResetDefaultActive,
      onClick: this.setParamToDefault,
      icon: isResetDefaultActive ? ResetDefaultIcon : ResetDefaultIconDisable,
    };
    const changeNameAdvSetupProperties = {
      id: APPDATA.ADV_SETUP_NAME,
      label: '',
      disabled: false,
      onClick: () => {
        this.handleShowKeyboardAdvSetupName();
      },
      icon: RenameIcon,
    };
    const secondaryButton = {
      id: 'AutoProfileHelp',
      onClick: this.handleTopMenuClick,
      className: 'help-icon',
      icon: HelpIcon,
      disabled: false,
    };
    if (editAdvSetup || (isRemoteView && advSetupSelected !== undefined)) {
      titleMenuProperties = `${APPDATA.ADVANCED_SETUP_NEW} - ${advSetupSelected.Name}`;
      consoleLog('setupTopMenuProperties isDefaultConfig', isDefaultConfig, advSetupSelected, titleMenuProperties);
      if (isDefaultConfig) {
        this.setSingleTopMenuProperties(
          buttonSaveSetupASProperties,
          backButtonProperties,
          titleMenuProperties,
          secondaryButton,
        );
      } else {
        this.setDoubleTopMenuProperties(
          buttonSaveASProperties,
          buttonSaveProperties,
          backButtonProperties,
          titleMenuProperties,
          secondaryButton,
          isRemoteView === true ? undefined : changeNameAdvSetupProperties,
        );
      }
    } else {
      // this.goToAdvSetupExplorerPage();
      this.setDoubleTopMenuProperties(
        button1Properties,
        button2Properties,
        backButtonProperties,
        titleMenuProperties,
        secondaryButton,
        resetDefaultProperties,
      );
    }
  };

  handleShowKeyboardAdvSetupNameSaveAs = () => {
    const {dispatch, advSetupSelected} = this.props;
    const {isDefaultConfig} = this.state;
    dispatch(
      modalActions.showKeyboard({
        keyboardValue: isDefaultConfig ? '' : advSetupSelected.Name,
        keyboardTitle: APPDATA.SAVE_AS,
        keyboardCallBack: this.handleKeyboardSaveAsChange,
        keyboardPlaceholder: 'Advance Setup Name',
        overwriteFirstInput: false,
        max: 100,
        keyboardCancel: () => dispatch(setupActions.setSaveAdvSetup(false)),
        // keyboardError: isKeyboardError,
      }),
    );
  };

  handleShowKeyboardAdvSetupName = () => {
    const {dispatch, advSetupSelected} = this.props;
    const {isDefaultConfig} = this.state;
    dispatch(
      modalActions.showKeyboard({
        keyboardValue: isDefaultConfig ? '' : advSetupSelected.Name,
        keyboardTitle: APPDATA.ADV_SETUP_NAME,
        keyboardCallBack: this.onChangeAdvSetupName,
        keyboardPlaceholder: 'Advance Setup Name',
        overwriteFirstInput: false,
        max: 100,
        keyboardCancel: () => dispatch(setupActions.setSaveAdvSetup(false)),
        // keyboardError: isKeyboardError,
      }),
    );
  };

  // onCancelKeyboard = () => {
  //   this.props.dispatch(setupActions.setSaveAdvSetup(false));
  // };
  handleKeyboardSaveAsChange = (e) => {
    const {dispatch} = this.props;
    const {latestName, isValid} = dispatch(validateNameAdvSetup(e.value, true));

    if (isValid)
      this.setState({
        beforeName: latestName,
      });

    // const {advSetupSelected, advSetupList} = this.props;
    // const _advSetupSelected = {...advSetupSelected};
    // const stringRegex = /[ `!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?~]/;
    // const findSameName = advSetupList.find((files) => files.Name.toLowerCase() === e.value.toLowerCase());

    // if (stringRegex.test(e.value)) {
    //   this.props.dispatch(
    //     setupActions.showAlert({
    //       alertShow: true,
    //       alertText: APPDATA.MESSAGES.ADV_SETUP.FIELD_ERROR.FILE_NAME_CONTAIN_SYMBOLS,
    //       alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
    //     }),
    //   );
    // } else if (e.value === '' || e.value === undefined) {
    //   this.props.dispatch(
    //     setupActions.showAlert({
    //       alertShow: true,
    //       alertText: APPDATA.MESSAGES.ADV_SETUP.FIELD_ERROR.FILE_NAME_CANNOT_BE_EMPTY,
    //       alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
    //     }),
    //   );
    // } else if (findSameName !== undefined) {
    //   this.props.dispatch(
    //     setupActions.showAlert({
    //       alertShow: true,
    //       alertText: APPDATA.MESSAGES.ADV_SETUP.FIELD_ERROR.FILE_NAME_ALREADY_EXIST,
    //       alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
    //     }),
    //   );
    // } else {
    //   this.setState({
    //     beforeName: _advSetupSelected[APPDATA.KEY.Name],
    //   });
    //   // advSetupSelected[APPDATA.KEY.Name] = e.value;
    //   batch(() => {
    //     // this.props.dispatch(setupActions.setTitleMenuProperties(APPDATA.ADVANCED_SETUP_NEW + " - " + e.value));
    //     this.props.dispatch(setupActions.setAdvSetupSelected({..._advSetupSelected, [APPDATA.KEY.Name]: e.value}));
    //     this.props.dispatch(setupActions.setDisableSaveSetupButton(true), () => {
    //       this.setupTopMenuProperties(this.state.isResetDefaultActive);
    //     });
    //   });

    //   const name = e.value;
    //   const address = APPDATA.API.POST_CREATE_ADV_SETUP;
    //   this.saveAdvSetupToBackend(address, -1, name, _advSetupSelected, false);
    // }
  };

  onChangeAdvSetupName = (e) => {
    const {dispatch} = this.props;
    const {isResetDefaultActive} = this.state;
    const {latestName, isValid} = dispatch(validateNameAdvSetup(e.value));

    if (isValid)
      this.setState(
        {
          beforeName: latestName,
        },
        () => {
          this.setupTopMenuProperties(isResetDefaultActive);
        },
      );

    // const {advSetupSelected, advSetupList} = this.props;
    // const _advSetupSelected = {...advSetupSelected};
    // const stringRegex = /[ `!@#$%^&*()_+\-=\\[\]{};':"\\|,.<>\\/?~]/;
    // const findSameName = advSetupList.find((files) => files.Name.toLowerCase() === e.value.toLowerCase());

    // if (stringRegex.test(e.value)) {
    //   // this.setState({isKeyboardError: true});
    //   this.props.dispatch(
    //     setupActions.showAlert({
    //       alertShow: true,
    //       alertText: APPDATA.MESSAGES.ADV_SETUP.FIELD_ERROR.FILE_NAME_CONTAIN_SYMBOLS,
    //       alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
    //     }),
    //   );
    // } else if (e.value === '' || e.value === undefined) {
    //   // this.setState({isKeyboardError: true});
    //   this.props.dispatch(
    //     setupActions.showAlert({
    //       alertShow: true,
    //       alertText: APPDATA.MESSAGES.ADV_SETUP.FIELD_ERROR.FILE_NAME_CANNOT_BE_EMPTY,
    //       alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
    //     }),
    //   );
    // } else if (findSameName !== undefined) {
    //   this.props.dispatch(
    //     setupActions.showAlert({
    //       alertShow: true,
    //       alertText: APPDATA.MESSAGES.ADV_SETUP.FIELD_ERROR.FILE_NAME_ALREADY_EXIST,
    //       alertStyle: APPDATA.ENUM.ALERT_TYPE.ALERT_DANGER,
    //     }),
    //   );
    // } else {
    //   this.setState({
    //     beforeName: _advSetupSelected[APPDATA.KEY.Name],

    //     // isKeyboardError: false,
    //   });
    //   // _advSetupSelected[APPDATA.KEY.Name] = e.value;
    //   batch(() => {
    //     this.props.dispatch(setupActions.setTitleMenuProperties(`${APPDATA.ADVANCED_SETUP_NEW} - ${e.value}`));
    //     this.props.dispatch(
    //       setupActions.setAdvSetupSelected({
    //         ..._advSetupSelected,
    //         [APPDATA.KEY.Name]: e.value,
    //       }),
    //     );
    //     this.props.dispatch(setupActions.setDisableSaveSetupButton(true), () => {
    //       this.setupTopMenuProperties(this.state.isResetDefaultActive);
    //     });
    //   });
    // }
  };

  setParamToDefault = () => {
    const {defaultConfigAdvSetupParams} = this.props;
    const defaultAdvSetup = PC_COMMON_FUNCTION.createNewJsonObject(defaultConfigAdvSetupParams);

    // this.props.dispatch(setupActions.updateCurrentAdvSetupParam(defaultAdvSetup));
    this.props.dispatch(setupActions.setAdvSetupSelected(defaultAdvSetup));
    this.setState(
      {
        isResetDefaultActive: false,
      },
      () => {
        this.setupTopMenuProperties(this.state.isResetDefaultActive);
      },
    );
  };

  setSingleTopMenuProperties = (
    topButtonProperties,
    backButtonProperties,
    titleMenuProperties,
    topButtonSecondaryButtonProperties,
    topButtonTertiaryProperties,
  ) => {
    // consoleLog("setSingleTopMenuProperties")
    // consoleLog(topButtonProperties)
    this.props.dispatch(
      setupActions.setTopMenuProperties({
        topButtonProperties:
          topButtonProperties === undefined
            ? undefined
            : {
                id: topButtonProperties.id,
                label: topButtonProperties.label,
                disabled: topButtonProperties.disabled,
                onClick: topButtonProperties.onClick,
              },
        backButtonProperties:
          backButtonProperties === undefined
            ? undefined
            : {
                id: backButtonProperties.id,
                label: backButtonProperties.label,
                disabled: backButtonProperties.disabled,
                onClick: backButtonProperties.onClick,
              },
        titleMenuProperties,
        topButtonSecondaryButtonProperties,
      }),
    );

    this.props.dispatch(setupActions.topButtonTertiaryProperties(topButtonTertiaryProperties));
  };

  setDoubleTopMenuProperties = (
    button1Properties,
    button2Properties,
    backButtonProperties,
    titleMenuProperties,
    topButtonSecondaryButtonProperties,
    topButtonTertiaryProperties,
  ) => {
    this.props.dispatch(
      setupActions.setDoubleTopMenuProperties({
        button1Properties:
          button1Properties === undefined
            ? undefined
            : {
                id: button1Properties.id,
                label: button1Properties.label,
                onClick: button1Properties.onClick,
                disabled: button1Properties.disabled,
              },
        button2Properties:
          button2Properties === undefined
            ? undefined
            : {
                id: button2Properties.id,
                label: button2Properties.label,
                onClick: button2Properties.onClick,
                disabled: button2Properties.disabled,
              },
        backButtonProperties: {
          id: backButtonProperties.id,
          label: '',
          disabled: backButtonProperties.disabled,
          onClick: backButtonProperties.onClick,
        },
        titleMenuProperties,
        topButtonSecondaryButtonProperties,
      }),
    );
    this.props.dispatch(setupActions.topButtonTertiaryProperties(topButtonTertiaryProperties));
  };

  backAction = () => {
    const {editAdvSetup, advSetupSelected, isRemoteView} = this.props;
    if (this.props.disableSaveSetupButton === false) {
      if (this.props.isRemoteView === true) {
        this.props.dispatch(setupActions.setEditAdvSetup(false));
        this.goToAutoSetupScreen();
      } else {
        this.goToAdvSetupExplorerScreen();
        // if (editAdvSetup) {
        // } else {
        //     this.goToAutoSetupScreen();
        // }
      }
    } else if (editAdvSetup || isRemoteView) {
      this.popUpBackButtonAlreadyEdit(false, this.onClickPopUpBackButton);
    } else if (advSetupSelected !== null) {
      this.popUpBackButtonAlreadyEdit(false, this.onClickPopUpBackButton);
    } else {
      this.popUpBackButtonAlreadyEdit(true, this.onClickPopUpBackButton);
    }
  };

  onClickPopUpBackButton = (e) => {
    const {editAdvSetup, advSetupSelected, isRemoteView, dispatch} = this.props;
    dispatch(modalActions.hidePopUp());
    switch (e.currentTarget.id) {
      case APPDATA.SAVE:
        if (editAdvSetup || isRemoteView) {
          // this.saveConfig(APPDATA.SAVE, false);
          // Trigger save from advanceCycleSetup State to Props
          dispatch(setupActions.setSaveAdvSetup(true));

          // this.saveConfig(APPDATA.SAVE, false);
          this.setState({triggerSave: true});
        } else {
          // this.saveConfig(APPDATA.SAVE, true);
          dispatch(setupActions.setSaveAdvSetup(true));
        }
        dispatch(setupActions.setButtonClickedTypeAdv(APPDATA.SAVE));
        break;
      case APPDATA.SAVE_AS:
        // if (editAdvSetup || isRemoteView) {
        this.handleShowKeyboardAdvSetupNameSaveAs();
        // this.saveConfig(APPDATA.SAVE_AS, false);
        // Trigger save from advanceCycleSetup State to Props
        // dispatch(setupActions.setSaveAdvSetup(true));
        // } else {
        // this.saveConfig(APPDATA.SAVE_AS, true);
        // this.handleShowKeyboardAdvSetupNameSaveAs();
        // }
        dispatch(setupActions.setButtonClickedTypeAdv(APPDATA.SAVE_AS));
        break;
      case APPDATA.DISCARD:
        if (editAdvSetup || isRemoteView) {
          if (isRemoteView === true) {
            dispatch(setupActions.setEditAdvSetup(false));
            this.goToAutoSetupScreen();
          } else {
            this.goToAdvSetupExplorerPage();
          }
          const beforeConfig = PC_COMMON_FUNCTION.createNewJsonObject(this.state.beforeConfig);
          dispatch(setupActions.setAdvSetupSelected(beforeConfig));
          // this.setSelectedAdvSetup(beforeConfig);
        } else {
          // newAdvSetupBackButton
          if (advSetupSelected === undefined) {
            // this.setSelectedAdvSetup(defaultConfigAdvSetupParams);
            this.setParamToDefault();
          }
          this.goToAutoSetupScreen();
        }
        break;
      default:
        break;
    }
    // this.props.dispatch(setupActions.setDisableSaveSetupButton(false));
  };

  // setSelectedAdvSetup = (advSetupSelected) => {
  // 	var advSetupSelected = PC_COMMON_FUNCTION.createNewJsonObject(advSetupSelected);
  // 	this.props.dispatch(setupActions.updateCurrentAdvSetupParam(advSetupSelected));
  // };

  handleTopMenuClick = (e) => {
    // const {editAdvSetup} = this.props;
    switch (e.currentTarget.id) {
      case APPDATA.SAVE:
        // Trigger save from advanceCycleSetup State to Props
        this.props.dispatch(setupActions.setSaveAdvSetup(true));
        // this.saveConfig(APPDATA.SAVE, false);
        this.setState({triggerSave: true});
        // consoleLog('SAVE CONFIG');
        this.props.dispatch(setupActions.setButtonClickedTypeAdv(APPDATA.SAVE));
        // this.props.dispatch(setupActions.setDisableSaveSetupButton(false));
        break;
      case APPDATA.SAVE_AS:
        // this.saveConfig(APPDATA.SAVE_AS, false);
        this.handleShowKeyboardAdvSetupNameSaveAs();
        // consoleLog('SAVE AS CONFIG');

        // this.props.dispatch(setupActions.setDisableSaveSetupButton(false));

        // Trigger save from advanceCycleSetup State to Props
        // this.props.dispatch(setupActions.setSaveAdvSetup(true));
        this.props.dispatch(setupActions.setButtonClickedTypeAdv(APPDATA.SAVE_AS));
        break;
      // case APPDATA.SAVE_SETUP_AS:
      //   this.saveConfig(APPDATA.SAVE_AS, false);
      //   consoleLog("SAVE SETUP AS CONFIG");
      //   this.props.dispatch(setupActions.setDisableSaveSetupButton(false));
      //   break;
      case APPDATA.FIND_SETUP:
        consoleLog('FIND SETUP CONFIG');
        if (this.props.isRemoteView === true) {
          this.props.dispatch(setupActions.setEditAdvSetup(false));
          this.goToAutoSetupScreen();
        } else {
          this.goToAdvSetupExplorerPage();
        }
        this.props.dispatch(setupActions.setDisableSaveSetupButton(false));
        break;
      case 'AutoProfileHelp':
        this.onClickHelp();
        break;
      default:
        break;
    }
  };

  popUpBackButtonAlreadyEdit = (isDisableSave, clickedButton) => {
    const {advSetupSelected} = this.props;
    let popUpButton = [
      {
        id: APPDATA.SAVE_AS,
        isPrimaryButton: true,
        onClick: clickedButton,
        label: APPDATA.SAVE_AS,
      },
      {
        id: APPDATA.SAVE,
        isPrimaryButton: true,
        onClick: clickedButton,
        label: APPDATA.SAVE,
        disabled: isDisableSave,
      },
      {
        id: APPDATA.DISCARD,
        isPrimaryButton: false,
        onClick: clickedButton,
        label: APPDATA.DISCARD,
      },
    ];
    if (advSetupSelected.Id === 0) {
      popUpButton = [
        {
          id: APPDATA.SAVE_AS,
          isPrimaryButton: true,
          onClick: clickedButton,
          label: APPDATA.SAVE_AS,
        },
        {
          id: APPDATA.DISCARD,
          isPrimaryButton: false,
          onClick: clickedButton,
          label: APPDATA.DISCARD,
        },
      ];
    }
    this.props.dispatch(
      modalActions.showPopUp({
        popUpTitle:
          advSetupSelected.Id === 0
            ? APPDATA.MESSAGES.ADV_SETUP.LEAVE_ADV_SETUP_SAVE_AS_TITLE
            : APPDATA.MESSAGES.ADV_SETUP.LEAVE_ADV_SETUP_SAVE_TITLE,
        popUpText:
          advSetupSelected.Id === 0
            ? APPDATA.MESSAGES.ADV_SETUP.LEAVE_ADV_SETUP_SAVE_AS
            : APPDATA.MESSAGES.ADV_SETUP.LEAVE_ADV_SETUP_SAVE,
        popUpQuestion: undefined,
        popUpButton,
      }),
    );
  };

  goToAutoSetupScreen = () => {
    this.setupTopMenuProperties(this.state.isResetDefaultActive);
    window.location.href = APPDATA.AUTO_PROFILE_SETUP;
  };

  // eslint-disable-next-line class-methods-use-this
  goToAdvSetupExplorerScreen = () => {
    // this.setupTopMenuProperties(this.state.isResetDefaultActive);
    window.location.href = APPDATA.ADVANCE_SETUP_EXPLORER;
  };

  // getBiggestId = () => {
  //   const {lastAdvSetupIdCreated} = this.props;
  //   const listLength = lastAdvSetupIdCreated === undefined ? 0 : lastAdvSetupIdCreated;
  //   let biggestId;
  //   if (listLength === 0) {
  //     biggestId = 1;
  //   } else {
  //     biggestId = parseInt(listLength, 10);
  //     biggestId += 1;
  //   }
  //   this.setState({
  //     totalAdvSetup: biggestId,
  //   });
  //   this.props.dispatch(setupActions.setLastAdvSetupIdCreated(biggestId));
  //   return biggestId;
  // };

  // saveAdvSetupToBackend = (address, id, name, advSetupSelected, isBackToAutoProfileButton) => {
  //   const {dispatch} = this.props;
  //   const passingValue = {isBackToAutoProfileButton, address};
  //   const param = {...advSetupSelected, [APPDATA.KEY.Id]: id, [APPDATA.KEY.Name]: name};

  //   consoleLog('Save Config Adv Setup', param);

  //   if (address === APPDATA.API.POST_CREATE_ADV_SETUP) {
  //     Post(address.replace(CREATE, ''), param, this.successSaveAdvSetup, passingValue);
  //   } else if (address === APPDATA.API.PUT_EDIT_ADV_SETUP) {
  //     dispatch(setupActions.setSaveAdvSetup(true));
  //   } else consoleError('NOT UPDATE');
  // };

  // successSaveAdvSetup = (response, passingValue) => {
  //   const {editAdvSetup, currentAdvSetupParams, isRemoteView} = this.props;
  //   const advSetupCreated = {};
  //   advSetupCreated[APPDATA.KEY.Id] = response.data.Id;
  //   advSetupCreated[APPDATA.KEY.Name] = response.data.Name;
  //   advSetupCreated[APPDATA.KEY.ConfigAdvSetup] = response.data.ConfigAdvSetup;
  //   this.props.dispatch(setupActions.setAdvSetupSelected(advSetupCreated));
  //   if (response.data.Id === currentAdvSetupParams.Id) {
  //     this.props.dispatch(setupActions.updateCurrentAdvSetupParam(advSetupCreated));
  //   }
  //   if (passingValue.address === APPDATA.API.POST_CREATE_ADV_SETUP) {
  //     this.props.dispatch(setupActions.setLastAdvSetupIdView(response.data.Id));
  //   }

  //   if (!editAdvSetup || isRemoteView) {
  //     this.props.dispatch(setupActions.setEditAdvSetup(false));
  //     if (passingValue.isBackToAutoProfileButton || isRemoteView) {
  //       this.goToAutoSetupScreen();
  //     } else {
  //       this.goToAdvSetupExplorerScreen();
  //     }
  //     // eslint-disable-next-line no-dupe-else-if
  //   } else if (isRemoteView) {
  //     this.goToAutoSetupScreen();
  //   } else {
  //     this.goToAdvSetupExplorerScreen();
  //   }
  //   this.props.dispatch(setupActions.setSaveAdvSetup(false));
  // };

  compareCurrentParamWithDefaultValue = (advSetupSelected) => {
    const {defaultConfigAdvSetupParams} = this.props;
    if (defaultConfigAdvSetupParams !== undefined) {
      const defaultConfig = PC_COMMON_FUNCTION.createNewJsonObject(defaultConfigAdvSetupParams);
      const currentConfig = PC_COMMON_FUNCTION.createNewJsonObject(advSetupSelected);

      const isDefaultConfigVal = this.isDefaultConfigValue(defaultConfig, currentConfig);
      if (_.isEqual(defaultConfig, currentConfig)) {
        // activeResetDefault
        this.setState(
          {
            isResetDefaultActive: true,
            isDefaultConfig: isDefaultConfigVal,
          },
          () => {
            consoleLog('compareCurrentParamWithDefaultValue', this.state);
            this.setupTopMenuProperties(this.state.isResetDefaultActive);
          },
        );
      } else {
        // disable reset default
        this.setState(
          {
            isResetDefaultActive: false,
            isDefaultConfig: isDefaultConfigVal,
          },
          () => {
            consoleLog('compareCurrentParamWithDefaultValue', this.state);
            this.setupTopMenuProperties(this.state.isResetDefaultActive);
          },
        );
      }
    }
  };

  // isCurrentValue = (name, defaultConfigAdvSetupParams, advSetupSelected) => {
  //   if (
  //     !_.isEqual(
  //       defaultConfigAdvSetupParams[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.MainAdvSetup][name],
  //       advSetupSelected[APPDATA.KEY.MainAdvSetup][name],
  //     )
  //   ) {
  //     return false;
  //   }
  //   if (
  //     !_.isEqual(
  //       defaultConfigAdvSetupParams[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.PrimeAdvSetup][name],
  //       advSetupSelected[APPDATA.KEY.PrimeAdvSetup][name],
  //     )
  //   ) {
  //     return false;
  //   }
  //   if (
  //     !_.isEqual(
  //       defaultConfigAdvSetupParams[APPDATA.KEY.ConfigAdvSetup][APPDATA.KEY.RecoveryAdvSetup][name],
  //       advSetupSelected[APPDATA.KEY.RecoveryAdvSetup][name],
  //     )
  //   ) {
  //     return false;
  //   }
  //   return true;
  // };

  // eslint-disable-next-line class-methods-use-this
  isDefaultConfigValue = (defaultConfigAdvSetupParams, advSetupSelected) => {
    if (advSetupSelected[APPDATA.KEY.Id] === 0) {
      return true;
    }
    if (_.isEqual(defaultConfigAdvSetupParams[APPDATA.KEY.Name], advSetupSelected[APPDATA.KEY.Name])) {
      return true;
    }
    return false;
  };

  onClickHelp = () => {
    this.setState(
      {
        isHelpModeEnable: true,
      },
      () => {
        consoleLog('onClickHelp', this.state);
      },
    );
  };

  onClosePopUpWizard = () => {
    this.props.dispatch(setupActions.updateMessageAutoProfileHelpParam(APPDATA.HOME_HELP));
    this.setState(
      {
        isHelpModeEnable: false,
        contentHelp: DataHelpHome,
        // onBackToTopButton: false,
      },
      () => {
        // this.setupTopMenuProperties(!this.props.isCompleteFill, this.props.lockAccess, this.props.ManualControlState);
      },
    );
  };

  goToAdvSetupExplorerPage() {
    this.props.dispatch(setupActions.setDisableSaveSetupButton(false));
    window.location.href = APPDATA.ADVANCE_SETUP_EXPLORER;
  }

  // saveConfig(typeSave, isBackToAutoProfileButton) {
  //   const {advSetupList, advSetupSelected} = this.props;
  //   const id = this.getBiggestId(advSetupList);
  //   consoleLog('saveConfig', id, this.props, this.state, typeSave);
  //   if (typeSave === APPDATA.SAVE) {
  //     // update
  //     const address = APPDATA.API.PUT_EDIT_ADV_SETUP;
  //     this.props.dispatch(setupActions.setSaveAdvSetup(true));
  //     // if (nextProps !== undefined) {
  //     //   this.saveAdvSetupToBackend(
  //     //     address,
  //     //     nextProps.advSetupSelected.Id,
  //     //     nextProps.advSetupSelected.Name,
  //     //     nextProps.advSetupSelected,
  //     //     isBackToAutoProfileButton,
  //     //   );
  //     // } else {
  //     this.saveAdvSetupToBackend(
  //       address,
  //       advSetupSelected.Id,
  //       advSetupSelected.Name,
  //       advSetupSelected,
  //       isBackToAutoProfileButton,
  //     );
  //     // }
  //   } else {
  //     // create
  //     // this.handleShowKeyboardAdvSetupNameSaveAs(true);
  //   }
  // }

  updateSaveButton(nextProps) {
    if (this.props.editAdvSetup !== nextProps.editAdvSetup) {
      this.setParamToDefault();
    }
    if (this.props.modeHelp !== nextProps.modeHelp) {
      // consoleLog("Auto profile top menu - modeHelp")
      let content;
      switch (nextProps.modeHelp) {
        case APPDATA.HOME_HELP:
          content = DataHelpHome;
          break;
        case APPDATA.CONCENTRATE_HELP:
          content = DataHelpConcentrate;
          break;
        case APPDATA.CONCENTRATE50ML_HELP:
          content = DataHelpConcentrateMoreThan50;
          break;
        case APPDATA.BUFFER_DISCRETE_HELP:
          content = DataHelpBufferDiscrete;
          break;
        case APPDATA.BUFFER_CONTINOUS_HELP:
          content = DataHelpBufferContinuous;
          break;
        case APPDATA.ADVANCED_SETUP_HELP:
          content = DataHelpAdvancedSetup;
          break;
        case APPDATA.MANUAL_CONTROL_HELP:
          content = DataHelpManualControl;
          break;
        case APPDATA.STATUS_GRAPH_HELP:
          content = DataHelpStatusAndGraph;
          break;
        case APPDATA.RECOVERY_HELP:
          content = DataHelpRecovery;
          break;
        default:
          content = DataHelpHome;
          break;
      }
      this.setState(
        {
          contentHelp: content,
        },
        () => {
          // consoleLog(this.state.contentHelp);
        },
      );
    }
  }

  updateCurrentAdv(nextProps) {
    const {editAdvSetup, isRemoteView, advSetupSelected, defaultConfigAdvSetupParams} = this.props;
    const {isResetDefaultActive} = this.state;
    const defaultAdvSetup = PC_COMMON_FUNCTION.createNewJsonObject(defaultConfigAdvSetupParams);
    const currentAdvSetup = PC_COMMON_FUNCTION.createNewJsonObject(nextProps.advSetupSelected);
    if (defaultAdvSetup !== currentAdvSetup) {
      if (!editAdvSetup || isRemoteView) {
        if (currentAdvSetup !== undefined) this.compareCurrentParamWithDefaultValue(currentAdvSetup);
      } else {
        this.setState(
          {
            isResetDefaultActive: false,
          },
          () => {
            this.setupTopMenuProperties(isResetDefaultActive);
          },
        );
      }
    }
    const beforeAdvSetup = PC_COMMON_FUNCTION.createNewJsonObject(advSetupSelected);
    if (beforeAdvSetup !== currentAdvSetup) {
      this.setupTopMenuProperties(isResetDefaultActive);
    }
  }

  render() {
    // const style = {
    //   constraint: {
    //     fontSize: this.props.fontSize,
    //   },
    // };
    // consoleLog("render", this.state);
    return (
      <PopUpWizard
        data={this.state.contentHelp}
        fontSize={this.props.fontSize}
        popUpWizardVisible={this.state.isHelpModeEnable}
        onClose={this.onClosePopUpWizard}
      />
    );
  }
}
